import { Drawer } from "melco-ui";
//import { useTranslation } from "react-i18next";
import { Drawer as DrawerType, useGenericDrawer } from "../../../../hooks/drawer/useGenericDrawer";
import { TransferLicense } from "../../TransferLicense";

type TransferLicenseDrawerProps = {
  drawer: DrawerType;
  license: any;
  onCloseDrawerCallBack: () => void
};

export const TransferLicenseDrawer: React.FC<TransferLicenseDrawerProps> = ({
  license,
  drawer,
  onCloseDrawerCallBack
}) => {
  //  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer()
  const { closeDrawer, isDrawerOpen } = drawer;

  const onCloseDrawerFn = () => {
    closeDrawer();
    onCloseDrawerCallBack();
  }

  return (

    <Drawer
      title={"Transfer License"}
      placement="right"
      width={1195}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
      {isDrawerOpen && <TransferLicense
        license={license}
        referenceDrawer={referenceDrawer}
        onCloseDrawer={onCloseDrawerFn}
      />}
    </Drawer>
  );
};
